export default (context, payload) => {
    const targetState = context.rootState[payload.targetId];
    const counties = context.rootState.appState.counties;

    const waSelected = targetState.state === 'WA';

    context.commit('setAttribute', {
        id: payload.targetId,
        attribute: 'countyOptions',
        value: waSelected ? counties : [],
    }, {
        root: true,
    });

    if (!waSelected) {
        context.commit('setAttribute', {
            id: payload.targetId,
            attribute: 'county',
            value: '',
        }, {
            root: true,
        });
    }
};